var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.526 0V0.0210315V2.12419C16.1469 2.69204 19.4205 6.88783 18.8521 11.5043C18.3679 15.332 15.3575 18.3711 11.526 18.8232V20.9264C17.3153 20.348 21.5257 15.2163 20.9468 9.43265C20.4731 4.43766 16.5048 0.494241 11.526 0ZM9.42079 0.0315473C7.36822 0.231347 5.41038 1.02003 3.81042 2.34502L5.31564 3.90135C6.49456 2.95493 7.91557 2.34502 9.42079 2.1347V0.0315473ZM2.32625 3.82774C0.999972 5.42614 0.21052 7.37156 0 9.43265H2.1052C2.3052 7.93941 2.89466 6.51978 3.83147 5.3315L2.32625 3.82774ZM14.1575 6.80371L9.0208 11.9354L6.78928 9.70606L5.67353 10.8207L9.0208 14.1647L15.2733 7.91838L14.1575 6.80371ZM0.010526 11.5358C0.221046 13.5969 1.03155 15.5423 2.33678 17.1407L3.83147 15.637C2.90518 14.4487 2.3052 13.029 2.11573 11.5358H0.010526ZM5.31564 17.1828L3.81042 18.6234C5.39985 19.9484 7.35769 20.7792 9.42079 21V18.8968C7.92609 18.7076 6.50508 18.1082 5.31564 17.1828Z",
    fill: "#6D95FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.a1788ac1e299dde9e23275d786289457.svg";
export { ForwardRef as ReactComponent };